// Features/Cart-Overscroll/CartBody.ts
var Selector_Footer_Static = `.Cart-Footer-Static`;
var Selector_Overscroll = `.Cart-Overscroll`;
var Selector_Questions = `.Cart-Questions`;
var Selector_Summary = `.Cart-Summary-Card`;
var Selector_Wrapper = `.CartItemWrapper`;
var Selector_Content = `.Drawer__Content`;
var Selector_Footer = `.Cart-Footer`;
var Selector_Items = `.Cart__ItemList`;
var Selector_Body = `.Drawer__Container`;

class CartBody extends HTMLElement {
  parts;
  connectedCallback() {
    this.queryElements();
    if (!this.parts.overscroll)
      return;
    const update = this.update.bind(this);
    window.addEventListener("resize", update);
    const observer = new ResizeObserver(update);
    observer.observe(this.parts.overscroll);
    observer.observe(this.parts.items);
    this.update();
  }
  queryElements() {
    this.parts = {
      overscroll: this.querySelector(Selector_Overscroll),
      questions: this.querySelector(Selector_Questions),
      summary: this.querySelector(Selector_Summary),
      content: this.querySelector(Selector_Content),
      footer: this.querySelector(Selector_Footer),
      fixed: this.querySelector(Selector_Footer_Static),
      items: this.querySelector(Selector_Items),
      body: this.querySelector(Selector_Body)
    };
  }
  get items() {
    return this.querySelectorAll(Selector_Wrapper);
  }
  update() {
    const { hasSpace, parts } = this;
    const { overscroll, footer } = parts;
    let height = overscroll.scrollHeight;
    height = hasSpace ? -height : 0;
    footer.style.bottom = `${height}px`;
    setTimeout(() => this.setShow(!hasSpace), 1);
  }
  get hasSpace() {
    const { items, parts } = this;
    const {
      content,
      summary,
      footer,
      overscroll,
      questions
    } = parts;
    const overscroll_height = overscroll.scrollHeight, questions_height = questions.scrollHeight, content_height = content.offsetHeight, summary_height = summary.scrollHeight, footer_height = footer.scrollHeight;
    const combined = Array.from(items).map((item) => item.scrollHeight).reduce((a, b) => a + b, 0);
    const gap = 16 * (items.length - 1);
    //! Magic 16 pixels ..
    const space = content_height - questions_height - summary_height - footer_height - combined - gap;
    return overscroll_height > space;
  }
  setShow(show) {
    const {
      overscroll,
      body,
      content,
      fixed
    } = this.parts;
    let height = content.offsetHeight;
    height -= fixed.scrollHeight;
    if (show)
      height -= overscroll.scrollHeight;
    body.style.minHeight = `${height}px`;
  }
}

// Features/Cart-Overscroll/mod.ts
customElements.define("cart-body", CartBody);
